import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import KeynotesPage from "@/pages/KeynotesPage";
import WorkshopsPage from "@/pages/WorkshopsPage";
import LibraryPage from "@/pages/LibraryPage";
import SchoolPage from "@/pages/SchoolPage";
import AILeadershipPage from "@/pages/AILeadershipPage";
import PerformanceByDesignPage from "@/pages/ScienceOfExtraordinaryPage";
import DiagnosticPage from "@/pages/DiagnosticPage";
import ReportPage from "@/pages/ReportPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import TermsPage from "@/pages/TermsPage";
import CookieConsentBanner from "@/components/CookieConsentBanner";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

// Conditional Footer - hide on specific pages
function ConditionalFooter() {
  const { pathname } = useLocation();
  const hideFooterPaths = ['/report', '/diagnostic', '/course'];
  
  if (hideFooterPaths.includes(pathname)) {
    return null;
  }
  
  return <Footer />;
}

// Conditional Navbar - hide on diagnostic page
function ConditionalNavbar() {
  const { pathname } = useLocation();
  const hideNavbarPaths = ['/diagnostic'];
  
  if (hideNavbarPaths.includes(pathname)) {
    return null;
  }
  
  return <Navbar />;
}

// Conditional Cookie Banner - hide on immersive funnel pages
function ConditionalCookieBanner() {
  const { pathname } = useLocation();
  const hideBannerPaths = ['/report', '/diagnostic', '/course'];

  if (hideBannerPaths.includes(pathname)) {
    return null;
  }

  return <CookieConsentBanner />;
}

function App() {
  return (
    <div className="min-h-screen bg-[#F4F1EC]">
      <BrowserRouter>
        <ScrollToTop />
        <ConditionalNavbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/keynotes" element={<KeynotesPage />} />
          <Route path="/workshops" element={<WorkshopsPage />} />
          <Route path="/library" element={<LibraryPage />} />
          <Route path="/school" element={<SchoolPage />} />
          <Route path="/ai-leadership" element={<AILeadershipPage />} />
          <Route path="/course" element={<PerformanceByDesignPage />} />
          <Route path="/diagnostic" element={<DiagnosticPage />} />
          <Route path="/report" element={<ReportPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/terms-and-conditions" element={<TermsPage />} />
        </Routes>
        <ConditionalFooter />
        <ConditionalCookieBanner />
        <Toaster position="bottom-right" theme="light" />
      </BrowserRouter>
    </div>
  );
}

export default App;
